import styled from 'styled-components';
import { theme } from '../../../assets/styles/theme';
import { TextMain } from '../../../components/typography/Texts';

export const SectionContainer = styled.section`
  display: flex;
  flex-direction: row;
  border: 1px solid ${theme.color.darkerGray};
  border-radius: 5px;
  height: 100%;
  width: 100%;
  padding: 10px;
`;

export const SectionSingleColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const SectionLeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 3;
`;

export const SectionRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 25% 75%;
  row-gap: 10px;
`;

export const DetailsTitle = styled(TextMain)`
  font-weight: bold;
`;

export const DetailsValue = TextMain;

export const InfoHeader = styled(TextMain)`
  width: 100%;
  text-align: center;
  align-self: center;
  padding: 0 50px;
`;

export const WarningHeader = styled(InfoHeader)`
  color: ${theme.color.red};
`;
